<script>
  import { createForm } from "svelte-forms-lib";
  import * as yup from "yup";
  
  import { subscribeEmail } from "./subscribe";
  import PrivacyPolicy from "./PrivacyPolicy.svelte";

  let disabled = false;
  let action = 'Subscrever';

  let privacyText = 'hidden';

  const privacyToggle = () => {
    if(privacyText == 'hidden')
      privacyText = '';
    else
      privacyText = 'hidden';
  }

  let STATE = {
    send: {
      error: null,
      isSent: false
    }
  }

  const { form, errors, isValidating, isValid, handleChange, handleSubmit } = createForm({
    initialValues: {
      email: "",
			privacy: false
    },
    validationSchema: yup.object().shape({
      email: yup.string().email('insira um formato de e-mail válido').required('insira o seu melhor e-mail'),
			privacy: yup.boolean().oneOf([true],'tem de aceitar a política de privacidade'),
    }),
    onSubmit: async values => {
      action = 'Aguarde...'
      disabled = true;
      const { error } = await subscribeEmail(values);
      if(!error) {
        STATE.send.isSent = true;
      } else {
        STATE.send.isSent = true;
        STATE.send.error = error;
      }
    	//alert(JSON.stringify(values));
    }
  });
</script>

<div class="flex h-64 text-center block">
{#if !STATE.send.isSent}
  <form class="block mt-10 p-5 text-center" name="registerForm" on:submit={handleSubmit}>
    <label class="block" for="email">Receba um e-mail assim que lançarmos 🚀 	</label>
		<input
      class="{$errors.email ? 'border-red-300' : ''} block w-full mx-auto my-2 p-2 border border-black rounded-md"
      id="email"
      type="text"
			name="email"
      on:change={handleChange}
      bind:value={$form.email}
      on:blur={handleChange}
      placeholder="o-seu-melhor@e-mail.com"
    />
		<label class="inline-flex items-center my-2">
			<input
				type="checkbox"
				class="form-checkbox h-6 w-6 text-green-500"
				name="privacy"
				on:change={handleChange}
				bind:value={$form.privacy}
			>
			<!-- svelte-ignore a11y-invalid-attribute -->
			<span class="ml-3">Li e aceito a vossa <a class="underline appearance-none text-black focus:text-black visited:text-black link:text-black hover:text-yellow-500" on:click={privacyToggle} href="#nooo">política de privacidade</a>.</span>

		</label>
    <div class="{privacyText} max-w-xs overscroll-none overflow-auto h-56 px-6 py-4 mb-6 text-sm text-left">
      <PrivacyPolicy/>
    </div>
		<button {disabled} class="block w-full mt-3 bg-white-400 {$isValid ? (disabled ? 'hover:bg-yellow-300' : 'hover:bg-green-500') : 'hover:bg-red-500'} text-black font-bold py-2 px-4 border-b-4 border-black hover:border-black-500 rounded">
		  {action}
		</button>
		<div class="h-20 p-5">
			<span class="block">{$errors.email}</span>
			<span class="block">{$errors.privacy}</span>
		</div>


  </form>
{:else}
  {#if STATE.send.error == null}
    <div class="w-full self-center">Subscrição efetuada com sucesso.<br />Até breve!</div>
  {:else}
    <span class="w-full self-center block text-red-500">{STATE.send.error}</span>
  {/if}
{/if}
</div>
